export enum PaymentStatusEnum {
  Paid = 'Pago',
  WaitingPayment = 'Aguardando pagamento',
  Denied = 'Negado',
  Canceled = 'Cancelado',
  PartialRefund = 'Estorno parcial',
  TotalRefund = 'Estorno total',
}
